import React from 'react';

export interface AppCardFooterProps {
    children?: React.ReactNode;
}

const AppCardFooter: React.FC<AppCardFooterProps> = ({ children }) => {
    return <div className="app-footer">{children}</div>;
};

export default AppCardFooter;
